import { formatCurrency, extractYearlyRevenue, extractNumberOfEmployees, normalizePaydex } from "./utils/Helper";

export default function getExecutiveData(data) {
  const {
    company,
    summaryRecord,
    overview,
    incomeStatement,
    balanceSheet,
    AgingDataForCompany,
    linkedInJSON,
    dnBFinancialV2Data,
    dnbJsonData,
  } = data;
  var ARCScore = "";
  var paymentIndex = "";
  var legalScore = "";
  var sectorScore = "";
  var alternativeScore = "";
  var countryScore = "";
  var riskScore = "";
  var recommendedLimit = "";  
  var approvedLimit = "";
  var previousApprovedLimit = "";
  var updatedApprovedLimit = "";
  var requestedLimit = "";
  var recommendedLimitOriginalCurrency = "";
  var recommendedLimitExchangeRateDate = "";
  var originalCurrencyCode = "";
  var underwritingReason = "";
  var currentArBalance = 0;
  var totalArBalance = 0;
  var termsRecommended = "";
  var currentRecommended = "";
  var paydex = "";
  var tenure = "";
  var avgCustomerPaymentDays = "";
  var arrear = 0;
  var delinquencyScore = "";
  var failureScore = "";
  var altmanZScore = "";
  var financialRiskScore = "";
  var arBalance30 = 0;
  var arBalance60 = 0;
  var arBalance90 = 0;
  var lastUpdatedDate = "";
  var isAgingCompany = false;

  let descriptionWikipedia = "";
  const regex = /\{\{Short description\|(.+?)\}\}/;
  const match = company.wikipedia?.content?.match(regex);
  if (match) {
     descriptionWikipedia = match[1];
  } else {
    console.log("No short description found");
  }

  // const WikiInfobox = company?.wikipedia?.infobox
  //   ? JSON.parse(company.wikipedia?.infobox)
  //   : {};
  const manualSource = company?.manualSource
    ? JSON.parse(company?.manualSource)
    : {};
  const google = company.googleSearch?.knowledgeGraph?.raw
    ? JSON.parse(company.googleSearch?.knowledgeGraph.raw)
    : {};
    
    function isValid(value) {
      return (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !Number.isNaN(value)
      );
    }

  const formatNumber = (number, currencySymbol = "US $") => {
    if(!isValid(number)) return null
    if (
      typeof number === "string" &&
      (number.includes("US $") ||
        number.includes("$") ||
        number.includes("billion") ||
        number.includes("million") ||
        number.includes(","))
    ) {
      return number;
    }
    if (!number || isNaN(parseFloat(number))) return "";
    const num = parseFloat(number);
    
    // Determine if we need a space (for currency codes like USD, EUR) or not (for symbols like $, €)
    const needsSpace = currencySymbol && currencySymbol.length >= 3 && !currencySymbol.includes("$");
    const separator = needsSpace ? " " : "";
    
    if (num >= 1e9 || num <= -1e9) {
      return `${currencySymbol}${separator}${(num / 1e9).toFixed(2)} billion`;
    } else if (num >= 1e6 || num <= -1e6) {
      return `${currencySymbol}${separator}${(num / 1e6).toFixed(2)} million`;
    } else if (num >= 1e3 || num <= -1e3) {
      // Use Intl.NumberFormat for thousands
      return `${currencySymbol}${separator}${num.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
    } else {
      return `${currencySymbol}${separator}${num}`;
    }
  };

  // Add this new function for simple number formatting without keywords
  const formatNumberSimple = (number, currencySymbol = "US $") => {
    if (!isValid(number)) return null;
    if (
      typeof number === "string" &&
      (number.includes("US $") ||
        number.includes("$") ||
        number.includes(","))
    ) {
      return number;
    }
    if (!number || isNaN(parseFloat(number))) return "";
    const num = parseFloat(number);
    
    // Determine if we need a space (for currency codes like USD, EUR) or not (for symbols like $, €)
    const needsSpace = currencySymbol && currencySymbol.length >= 3 && !currencySymbol.includes("$");
    const separator = needsSpace ? " " : "";
    
    return `${currencySymbol}${separator}${num.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
  };

  const constrainValue = (value, low, high) => {
    return Math.max(Math.min(parseFloat(value), high), low);
  }

  const formatArcScore = (value) => {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    return constrainValue(parseFloat(value)?.toFixed(1), 1, 10);
  }


  //--------------financial info--------

  const getDnbRevenueByYear = (dnbFinancials, year) => {
    if (!dnbFinancials) return null;

    const previousFinancials = Array.isArray(dnbFinancials.previousFinancials)
      ? dnbFinancials.previousFinancials
      : [];
    if (!dnbFinancials) return;
    const allFinancials = [
      dnbFinancials?.latestFinancials || [],
      ...previousFinancials,
    ];

    const matchingFinancial = allFinancials.find(
      (financial) =>
        financial &&
        financial.financialStatementToDate &&
        financial.financialStatementToDate.includes(year) &&
        financial.currency === "USD"
    );

    if (matchingFinancial && matchingFinancial.overview) {
      let salesRevenue = matchingFinancial.overview.salesRevenue;
      const units = matchingFinancial.units || "SingleUnits";

      if (units === "Million") {
        salesRevenue *= 1000000;
      } else if (units === "Billion") {
        salesRevenue *= 1000000000;
      }

      return salesRevenue;
    }

    const currentYear = new Date().getFullYear();
    const lastYear = currentYear - 1;

    if (year === lastYear && dnbJsonData) {
      const yearlyRevenue =
        dnbJsonData?.organization?.globalUltimate?.financials?.[0]?.yearlyRevenue || [];
      const usdRevenue = yearlyRevenue.find((item) => item.currency === "USD");

      if (usdRevenue) {
        return usdRevenue.value;
      }
    }

    return null;
  };

  
  function getFinancialRevenue(allSources) {
    const { financialStatement, AV, companySearch, wiki, SF, dnbFinancials } =
      allSources;
    let revenueByYear = {};
    const currentYear = new Date().getFullYear();
    const lastThreeYears = [currentYear - 1, currentYear - 2, currentYear - 3];
    const lastYear = currentYear - 1;

    const getRevenueFromSource = (source, year) => {
      if (year === lastYear && manualSource?.revenue) {
        return manualSource?.revenue;
      }
      if (!source) return null;
      switch (source) {
        case "financialStatement":
          return (
            financialStatement?.annualReports?.find((rep) =>
              rep?.fiscalDateEnding?.includes(year)
            )?.totalRevenue ||
            financialStatement?.annualReports?.find((rep) =>
              rep?.fiscalDateEnding?.includes(year)
            )?.salesRevenue ||
            financialStatement?.annualReports?.find((rep) =>
              rep?.fiscalDateEnding?.includes(year)
            )?.netSales
          );
        case "AV":
          return AV?.incomeStatement?.annualReports?.find((rep) =>
            rep?.fiscalDateEnding?.includes(year)
          )?.totalRevenue;
        case "companySearch":
          return companySearch?.financial_data?.data?.revenue?.[year];
        case "wiki":
          if (wiki?.revenue?.manual === true) {
            return wiki.revenue.value;
          } else if (wiki?.revenue) {
            return wiki.revenue;
          }
          return null;
        case "SF":
          return SF?.financial_data?.[year];
        case "dnbFinancials":
          return getDnbRevenueByYear(dnbFinancials?.organization, year);
        default:
          return null;
      }
    };

    let avRevenues = [];
    let dnbRevenues = [];
    let avDataAvailable = true;

    lastThreeYears.forEach((year) => {
      const avRevenue = getRevenueFromSource("AV", year);
      if (!avRevenue) avDataAvailable = false;
      avRevenues.push(avRevenue);
    });

    lastThreeYears.forEach((year) => {
      const dnbRevenue = getRevenueFromSource("dnbFinancials", year);
      dnbRevenues.push(dnbRevenue);
    });

    if (!financialStatement && !avDataAvailable) {
      const revenues = [
        getRevenueFromSource("companySearch", currentYear - 1),
        getRevenueFromSource("SF", currentYear - 1),
        getRevenueFromSource("wiki", currentYear - 1),
      ].filter(Boolean);

      if (revenues.length > 0) {
        const maxRevenue = Math.max(...revenues);
        const minRevenue = Math.min(...revenues);

        if (maxRevenue / minRevenue > 1.25) {
          revenueByYear[currentYear - 1] = `Range: ${formatNumber(
            minRevenue
          )} - ${formatNumber(maxRevenue)}`;
        } else {
          revenueByYear[currentYear - 1] = formatNumber(revenues?.[0]);
        }
      } else {
        lastThreeYears.forEach((year, index) => {
          const dnbRevenue = dnbRevenues[index];
          if (dnbRevenue) {
            revenueByYear[year] = formatNumber(dnbRevenue);
          } else {
            revenueByYear[year] = null;
          }
        });
      }
    } else {
      lastThreeYears.forEach((year, index) => {
        const financialStatementRevenue = getRevenueFromSource(
          "financialStatement",
          year
        );
        const avRevenue = avRevenues[index];

        if (financialStatementRevenue) {
          revenueByYear[year] = formatNumber(financialStatementRevenue);
        } else if (avRevenue) {
          revenueByYear[year] = formatNumber(avRevenue);
        } else if (year === currentYear - 1) {
          const otherRevenues = [
            getRevenueFromSource("companySearch", year),
            getRevenueFromSource("SF", year),
            getRevenueFromSource("wiki", year),
          ].filter(Boolean);
          if (otherRevenues.length > 0) {
            const maxRevenue = Math.max(...otherRevenues);
            const minRevenue = Math.min(...otherRevenues);

            if (maxRevenue / minRevenue > 1.25) {
              revenueByYear[year] = `Range: ${formatNumber(
                minRevenue
              )} - ${formatNumber(maxRevenue)}`;
            } else {
              revenueByYear[year] = formatNumber(otherRevenues?.[0]);
            }
          } else {
            revenueByYear[year] = null;
          }
        }
      });
    }
    return revenueByYear;
  }

  var revenues = getFinancialRevenue({
    AV: { overview, balanceSheet, incomeStatement },
    // wiki: WikiInfobox,
    dnbFinancials: dnBFinancialV2Data,
  });

  //---------------financial info card------------

  const main_competitors = "";
  const summary = summaryRecord?.summaryData || null;
  if (summary) {

    isAgingCompany = Object.keys(summary).some(
      (key) =>
        key.includes("AR Balance") &&
        summary[key] !== null &&
        summary[key] !== 0 &&
        summary[key] !== ""
    );
  
    ARCScore = formatArcScore(summary["Combined Score"]);
    paymentIndex = summary["Paydex"] != null && parseFloat(summary["Paydex"]) != 0
        ? normalizePaydex(summary["Paydex"])
        : 0;
    legalScore = parseFloat(summary["Legal Score"]);
    sectorScore = parseFloat(summary["Sector Score"]);
    alternativeScore = parseFloat(summary["Alternative Score"]);
    countryScore = parseFloat(summary["Country Score"]);
    delinquencyScore = summary["Delinquency Score"]
      ? parseFloat(summary["Delinquency Score"])
      : undefined;
    failureScore = summary["Failure Score"]
      ? parseFloat(summary["Failure Score"])
      : undefined;
    riskScore = summary["Risk Segment"]
      ? parseFloat(summary["Risk Segment"])
      : undefined;
    altmanZScore = summary["Altman Z Score"]
      ? parseFloat(summary["Altman Z Score"])
      : undefined;
    financialRiskScore = summary["Financial Risk Score"]
      ? parseFloat(summary["Financial Risk Score"])
      : undefined;
    recommendedLimit = formatNumberSimple(summary["Recommended Limit"])
    recommendedLimitOriginalCurrency = formatNumber(summary["Recommended Limit Original Currency"], summary["Original Currency Code"] || summary["Original Currency Symbol"])
    recommendedLimitExchangeRateDate = summary["Exchange Rate Date"]
    originalCurrencyCode = summary["Original Currency Code"] || "USD"
    requestedLimit =  company?.requestedCreditLimit
    ? formatCurrency(company?.requestedCreditLimit)
    : "";    
    approvedLimit = formatNumberSimple(company?.approvedLimit || 0);
    previousApprovedLimit = company?.previousApprovedLimit != null ? formatNumberSimple(company.previousApprovedLimit) : "";
    updatedApprovedLimit = company?.updatedApprovedLimit != null ? formatNumberSimple(company.updatedApprovedLimit) : "";

    if (summary["Type Last Updated At"]) {
      var date = new Date(summary["Type Last Updated At"]);
      var day = String(date.getDate()).padStart(2, "0");
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var year = date.getFullYear();

      lastUpdatedDate = `${day}/${month}/${year}`;
    }
    const sanitizeValue = (value) => {
      return isNaN(value) || value === undefined || value === null || value === "" ? 0 : value;
    };
    let arBalance30Value = sanitizeValue(summary["AR Balance Aging 30"]);
    let arBalance60Value = sanitizeValue(summary["AR Balance Aging 60"]);
    let arBalance90Value = sanitizeValue(summary["AR Balance Aging 90"]);

    arrear = formatCurrency(arBalance30Value + arBalance60Value + arBalance90Value);
    currentArBalance = formatCurrency(summary["Current AR Balance"]);
    totalArBalance = formatCurrency(summary["Total AR Balance"]);
    arBalance30 = formatCurrency(summary["AR Balance Aging 30"]);
    arBalance60 = formatCurrency(summary["AR Balance Aging 60"]);
    arBalance90 = formatCurrency(summary["AR Balance Aging 90"]);
    let recommendedNet = summary["Recommended Net"];
    if (recommendedNet && recommendedNet.startsWith("Net ")) {
      recommendedNet = recommendedNet.substring(4);
    }
    recommendedNet = parseInt(recommendedNet) || "-";
    termsRecommended = recommendedNet;

    let currentNet = summary["Current Net"];
    if (currentNet && currentNet.startsWith("Net ")) {
      currentNet = currentNet.substring(4);
    }
    currentNet = parseInt(currentNet) || "-";
    currentRecommended = currentNet;

    paydex = summary["Paydex"] ? parseInt(summary["Paydex"]) : "-";
    tenure = summary["Tenure"] ? parseInt(summary["Tenure"]) : "-";
    avgCustomerPaymentDays = summary["AVG Customer Payment Days"]
      ? summary["AVG Customer Payment Days"]
      : "-";

    underwritingReason = summary["Underwriting Reason"];
  }

  const summaryScores = {
    ARCScore: ARCScore,
    paymentIndex: paymentIndex,
    legalScore: legalScore,
    sectorScore: sectorScore,
    alternativeScore: alternativeScore,
    countryScore: countryScore,
    riskScore: riskScore,
    recommendedLimit: recommendedLimit,
    recommendedLimitOriginalCurrency: recommendedLimitOriginalCurrency,
    recommendedLimitExchangeRateDate: recommendedLimitExchangeRateDate,
    originalCurrencyCode: originalCurrencyCode,
    requestedLimit: requestedLimit,
    currentArBalance: currentArBalance,
    totalArBalance: totalArBalance,
    arBalance30: arBalance30,
    arBalance60: arBalance60,
    arBalance90: arBalance90,
    termsRecommended: termsRecommended,
    currentRecommended: currentRecommended,
    paydex: paydex,
    tenure: tenure,
    avgCustomerPaymentDays: avgCustomerPaymentDays,
    underwritingReason: underwritingReason,
    delinquencyScore: delinquencyScore,
    failureScore: failureScore,
    altmanZScore: altmanZScore,
    financialRiskScore: financialRiskScore,
    lastUpdatedDate: lastUpdatedDate,
    arrear,
    isAgingCompany,
    approvedLimit: approvedLimit,
    previousApprovedLimit: previousApprovedLimit,
    updatedApprovedLimit: updatedApprovedLimit,
  };

  const financialInfo = {
    last3yrRevenue: revenues,
  };

  return { summaryScores, financialInfo };
}
